export default "__VITE_ASSET__DmQeWQV___"